module.exports = __webpack_public_path__ + "img/Logo.8d1c67ee.svg";